"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BedStatusEnum;
(function (BedStatusEnum) {
    BedStatusEnum["All"] = "All";
    BedStatusEnum["Available"] = "Available";
    BedStatusEnum["Occupied"] = "Occupied";
    BedStatusEnum["OutOfService"] = "Out of service";
})(BedStatusEnum = exports.BedStatusEnum || (exports.BedStatusEnum = {}));
